<template>
  <section
    class="grid grid-rows-[auto_1fr_auto]"
    :class="[
      offer.classes,
      {
        'border-primary-950 rounded-2xl border-2': offer.id === 'academy',
      },
    ]"
  >
    <header class="mb-6 md:mb-8 lg:min-h-[90px]">
      <p class="mb-1 text-3xl font-bold">
        {{ offer.title }}
      </p>
      <h3 class="text-lg">
        {{ offer.subtitle }}
      </h3>
    </header>

    <div>
      <app-check-list
        class="sm:text-lg"
        :icon-size="20"
        :items="offer.features"
      />
    </div>

    <footer class="mt-8 grid gap-3">
      <slot name="footer_prepend" />

      <growth-contact-button
        block
        :color="offer.id === 'academy' ? 'accent' : 'primary'"
        origin="enterprise"
        :origin_page_action="`${offer.id}_offer_cta`"
        size="xl"
      />
      <div class="mt-3 text-center">
        <p class="mb-3 text-sm italic">Ils l'utilisent déjà</p>
        <ul class="flex justify-center gap-2">
          <li v-for="customer in offer.enrolled_customers" :key="customer.name">
            <app-image
              :alt="customer.name"
              class="rounded border bg-white p-2"
              :height="36"
              :src="customer.logo"
            />
          </li>
        </ul>
      </div>
    </footer>
  </section>
</template>

<script lang="ts" setup>
import type { OfferCardDefinition } from "~/business-areas/offer/composables/offer-list.hook";

defineProps<{
  offer: OfferCardDefinition;
}>();
</script>
